import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'limit',
    pure: false,
    standalone: false
})
export class LimitPipe implements PipeTransform {

  transform(items: Object[], limitData: any): Object[] {

    const startFrom = limitData.startFrom;
    const maxItems = limitData.maxItems;
    let start = startFrom - 1 ;
    if (start < 0) {
      start = 0;
    }

    const end = start + maxItems - 1;
    const pageItems = [];

    for (let i = start; i <= end; i++) {
      if (items[i]) {
        pageItems.push(items[i]);
      }
    }

    return pageItems;
  }

}
